import { Component, OnInit, Input, Output, EventEmitter, HostListener } from '@angular/core';
import { FormGroup, FormControl } from '@angular/forms';
import { ActivatedRoute } from '@angular/router';
import { APIService } from '../service/api.service';
import { forkJoin, of } from 'rxjs';

@Component({
  selector: 'app-barra-busca',
  templateUrl: './barra-busca.component.html',
  styleUrls: ['./barra-busca.component.scss'],
})
export class BarraBuscaComponent implements OnInit {
  // tslint:disable-next-line:no-input-rename
  @Input('componenteRef') componenteAtual: string;
  @Input() eixos?: [];
  @Input() filtros?: any;
  @Input() mensagem?: any;
  @Input() filtroArea?: any;
  @Input() areas: [];
  @Input() msgSemArea?: any;
  @Input() labelInput?: any = 'Nome';

  @Output() inputEvent = new EventEmitter<any>();

  ordenarPor = [
    { id: 'asc', nome: 'Ordem Alfabética (A - Z)' },
    { id: 'desc', nome: 'Ordem Alfabética (Z - A)' },
  ];

  filtrarPor = [
    { id: 'vigentes', nome: 'Cursos vigentes' },
    { id: 'mudaramnome', nome: 'Tabela de Convergência' },
    { id: 'naopermitidos', nome: 'Tabela de Submissão' },
  ];

  searchString: any;
  toggle = false;
  formularioPesquisa: FormGroup;
  filtroPadrao: string;
  areasTecnologicas: any;
  eixoId: any;
  areaId: any;
  ordenacao: any;
  mostrarArea = true;
  selectedValue: any;

  dropdownAbertoEixo = false;
  dropdownAbertoArea = false;
  dropdownAbertoTipo = false;
  dropdownAbertoOrder = false;
  areaSelecionada: any;
  eixoSelecionado: any;
  filtroSelecionado: any;
  ordenacaoSelecionada: any;

  eixo$: any;
  area$: any;

  eixo: any;
  area: any;

  constructor(
    private route: ActivatedRoute,
    private api: APIService
  ) {
  }

  ngOnInit(): void {
    this.route.queryParams.subscribe((q) => {
      this.eixoId = q.eixoId ? q.eixoId : q.id;
      this.searchString = q.query ? q.query : '';
      this.filtroPadrao = q.filtro ? q.filtro : '';
      this.ordenacao = q.ordenacao ? q.ordenacao : '';
      this.areaId = q.areaId ? q.areaId : '';
    });

    this.eixo$ = this.eixoId ? this.api.getEixo(this.eixoId) : of('');
    this.area$ = this.areaId ? this.api.getAreaTecnologicaById(this.areaId) : of('');

    forkJoin([this.eixo$, this.area$]).subscribe(([eixo, area]: any[]) => {
      this.eixo = eixo.nome;
      this.area = area.nome;
      this.createForm();
      this.checkEixo();
      this.checkArea();
    });
  }

  createForm() {
    this.formularioPesquisa = new FormGroup({
      stringBusca: new FormControl(this.searchString ? this.searchString : null),
      ordenacao: new FormControl(this.ordenacao ? this.ordenarPor.find(e => e.id === this.ordenacao).nome : null),
      filtro: new FormControl(this.filtroPadrao ? this.filtrarPor.find(e => e.id === this.filtroPadrao).nome : null),
      eixo: new FormControl(this.eixo$ ? this.eixo : null),
      areaTecnologica: new FormControl(this.area$ ? this.area : null),
    });

    this.ordenacaoSelecionada = this.ordenacao;
    this.filtroSelecionado = this.filtroPadrao;
    this.eixoSelecionado = this.eixoId;
    this.areaSelecionada = this.areaId;

  }

  checkArea() {
    if (this.filtroArea) {
      if (this.areaSelecionada) {
        this.api.getAreaTecnologicaById(this.areaId
          ? this.areaId
          : 0).subscribe((area: any) => {
            this.area = area.nome;
            this.formularioPesquisa.get('areaTecnologica').setValue(this.area);
          });
      } else {
        this.areaSelecionada = '';
        this.formularioPesquisa.get('areaTecnologica').setValue('');
      }

      this.areasTecnologicas = this.areas;
    }
  }

  checkEixo() {
    const eixoSelecionado = this.formularioPesquisa.get('eixo').value;
    if (eixoSelecionado) {
      this.buscarAreas();
    }

    // this.formularioPesquisa.get('eixo').valueChanges.subscribe(value => {
    //   if (value) {
    //     this.buscarAreas();
    //     this.formularioPesquisa.get('areaTecnologica')?.setValue('');
    //   }
    //   else {
    //     this.areasTecnologicas = [];
    //     this.formularioPesquisa.get('areaTecnologica').reset();
    //   }
    // });
  }

  @HostListener('document:click', ['$event'])
  onClickOutside(event: Event) {
    const dentroDeElementoPermitido = this.temClassePermitida(event.target, ['fa-angle-down', 'ng-valid']);

    // Se o clique foi dentro de um dropdown, não fecha lista.
    if (dentroDeElementoPermitido) {
      return;
    }

    // Se o clique foi fora de um dropdown, fecha lista.
    this.dropdownAbertoEixo = false;
    this.dropdownAbertoArea = false;
    this.dropdownAbertoTipo = false;
    this.dropdownAbertoOrder = false;
  }

  /**
   * @param target elementos do documento.
   * @param classesPermitidas classes de estilos.
   * @returns true ou false.
   */
  temClassePermitida(target: EventTarget, classesPermitidas: string[]): boolean {
    if (target instanceof HTMLElement) {
      return classesPermitidas.some(classe => target.classList.contains(classe));
    }
    return false;
  }

  /**
   * @param target elementos do documento.
   * @returns true ou false.
   */
  estaDentroDeDropdown(target: EventTarget): boolean {
    const dropdowns = document.querySelectorAll('.br-list[expanded]');
    return Array.from(dropdowns).some(dropdown => dropdown.contains(target as Node));
  }

  onPesquisar() {
    this.toggle = this.toggle ? !this.toggle : this.toggle;

    this.formularioPesquisa.get('eixo')?.setValue(this.eixoSelecionado);
    this.formularioPesquisa.get('areaTecnologica')?.setValue(this.areaSelecionada);
    this.formularioPesquisa.get('filtro')?.setValue(this.filtroSelecionado);
    this.formularioPesquisa.get('ordenacao')?.setValue(this.ordenacaoSelecionada);

    this.inputEvent.emit(this.formularioPesquisa.value);
  }

  atualizarVisibilidadeArea(valor: any) {
    // IDs que inibem a área
    const idsInibemArea = ['mudaramnome', 'naopermitidos'];
    this.mostrarArea = !idsInibemArea.includes(valor);
    if (!this.mostrarArea) {
      this.formularioPesquisa.get('areaTecnologica')?.setValue('');
      this.areaSelecionada = undefined;
    }
  }

  limparFiltro() {
    this.formularioPesquisa.reset(); // Limpa campos
    this.areaSelecionada = '';
    this.eixoSelecionado = '';
    this.filtroSelecionado = '';
    this.ordenacaoSelecionada = '';
    this.mensagem = '';
  }

  toggleDropdown(tipo: any) {
    this.dropdownAbertoEixo = tipo === 'eixo' ? !this.dropdownAbertoEixo : false;
    this.dropdownAbertoArea = tipo === 'area' ? !this.dropdownAbertoArea : false;
    this.dropdownAbertoTipo = tipo === 'tipo' ? !this.dropdownAbertoTipo : false;
    this.dropdownAbertoOrder = tipo === 'ordenacao' ? !this.dropdownAbertoOrder : false;
  }

  /**
   * @param tipos tipo do combo.
   * @param nome valor que aparece no combo.
   * @param id id do valor do combo.
   */
  selecionarItem(tipos: any, nome: any, id: any | null) {
    if (tipos === 'area') {
      this.areaSelecionada = id;
      this.formularioPesquisa.get('areaTecnologica')?.setValue(nome);
      this.dropdownAbertoArea = false;
    } else if (tipos === 'eixo') {
      this.eixoSelecionado = id;
      this.formularioPesquisa.get('eixo')?.setValue(nome);
      this.dropdownAbertoEixo = false;

      this.buscarAreas();
      this.formularioPesquisa.get('areaTecnologica')?.setValue('');
    } else if (tipos === 'tipo') {
      this.filtroSelecionado = id;
      this.formularioPesquisa.get('filtro')?.setValue(nome);
      this.dropdownAbertoTipo = false;

      const obj = this.filtrarPor.find(item => item.nome === nome);
      if (obj) {
        this.atualizarVisibilidadeArea(obj.id);
      }
    } else if (tipos === 'ordenacao') {
      this.ordenacaoSelecionada = id;
      this.formularioPesquisa.get('ordenacao')?.setValue(nome);
      this.dropdownAbertoOrder = false;
    }
  }

  onSelectChange(event: Event): void {
    const selectedRadio = event.target as HTMLInputElement;
    this.selectedValue = selectedRadio.checked;
  }

  alteraMensagem(novaMensagem: string) {
    this.mensagem = novaMensagem;
  }

  buscarAreas() {
    this.api.getFormAreasTecnologicas(this.eixoSelecionado
      ? this.eixoSelecionado
      : 0).subscribe((areas: any) => {
        this.areasTecnologicas = areas;
      });
  }

}
